export default __webpack_public_path__ + "static/media/LAS0500.34I-30407_-25433_0.7d1978c6.jpg";